"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInput = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Input = _interopRequireDefault(require("../Input"));

var _templateObject;

/* istanbul ignore next */
var StyledInput = (0, _styledComponents.default)(_Input.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n.MuiInputBase-input {\n  &:hover {\n    cursor: pointer;\n  }\n  &.Mui-disabled {\n    cursor: not-allowed;\n  }\n}\n"])));
exports.StyledInput = StyledInput;